import React from "react";
import { Badge as BagdeElem } from "reactstrap";
import { getSize } from "../../utils/size";
import { classnames } from "../../utils/text";

const Badge = ({
  color = "secondary", // primary, secondary, success, 
  // danger, warning, info, light, dark
  label,
  size = "md", // lg, md, sm
  style = {},
  disabled = false,
  children,
  className
}) => {
  return <BagdeElem
    className={classnames(`badge-${getSize(size)}`, className)}
    disabled={disabled}
    style={style}
    color={color.toLowerCase()}
  >
    {children || label}
  </BagdeElem>
}
export default Badge